import styled from "styled-components";
import { Tab, TabList } from 'react-tabs';

export const MainContainer = styled.div`
  font-size: 16px;
  Columnor: #000000;
  padding: 0% 1.5%;
`;
export const CustomTabList = styled(TabList)`
list-style-type:none;
display:flex;
justify-content:space-between;
width:100%;
padding:0px;
`
export const CustomTab = styled(Tab)`
border-radius:10px;
color:${props => props.primary ? "#FFFFFF" : "#0BA9DB"};
border:${props => props.primary ? "none" : "1px solid #0BA9DB"};
background: ${props => props.primary ? "linear-gradient(96.3deg, #0BA9DB 27.72%, #0F62C5 118.1%)" : "#FFFFFF"} ;
padding:0px 30px;
cursor:pointer;

`
export const MatchTab = styled(CustomTab)`
border-radius: ${props => props.borderRadius || "24px"};
max-width:${props => props.maxWidth};
width:100%;
padding:${props => props.padding || "5px 30px"};
margin:${props => props.margin};
min-width:${props => props.minWidth || "130px"};
outline: none;
`
export const Heading = styled.div`
cursor:${props => props.cursor || "auto"};
font-weight: ${props => props.fontWeight || "600"};
font-size:  ${props => props.fontSize || "24px"};
text-align:${props => props.textAlign || "left"};
color: ${props => props.color || "#000000"};
padding-bottom:${props => props.paddingBottom || "0px"};
width: ${props => props.width || "auto"};
margin: ${props => props.margin || "auto"};
@media (max-width:1399px) {
    font-size: ${props => props.mdFont}
  }
  @media (max-width:450px) {
    font-size: ${props => props.smFont};
    width:${props => props.smWidth}
  }
`

export  const Input = styled.input`
font-size:16px;
border:1px solid #CFCFD3;
width:100%;
border-radius:25px;
height: 50px;
padding: 0px 20px;
margin: 10px 0px;
  @media (max-width:450px) {
    font-size: ${props => props.smFont};
    height:40px;
  }
`
export  const Section = styled.div`
margin-bottom:25px;
`
export const MainBox = styled.div`
padding:0px 50px 30px 50px;

`;

export const Image = styled.img`
width:${props => props.width || "30px"};
margin-right:${props => props.margin || "0px"};
height:${props => props.height || "auto"};
margin-top:${props => props.marginTop || "0px"};
@media (max-width:1399px) {
    max-width: ${props => props.mdWidth}
  }
@media (max-width:415px) {
    max-width: ${props => props.xsWidth};
    margin: ${props => props.xsMargin}
  }
`
export const DeleteButton = styled.button`
transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
border: 1px solid rgba(211, 47, 47, 0.5);
color: #d32f2f;
text-align: center;
text-decoration: none;
display: inline-block;
font-size: 16px;
border-radius: 7px;
width: 80px;
height:32px;
margin: 10px;
`
export const RowDiv = styled.div`
margin: 10px;
`
export const ButtonDiv = styled.button`
background-color: ${props => props.background || "white"};
border: 1px solid rgba(25, 118, 210, 0.5);
color: ${props => props.color || "#FFFFFF"};
text-align: center;
text-decoration: none;
display: inline-block;
font-size: 14px;
border-radius: 5px;
width: 100%;
height:auto;
margin: ${props => props.margin || "auto 0px"};
max-height: 40px;
`
export const HeaderDiv = styled.div`
display: flex;
justify-content: space-between;

`
export const ImageDiv = styled.div`
margin: 10px;

`